var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs flex",on:{"mouseleave":function($event){_vm.checkvalue=_vm.oldValue}}},_vm._l((_vm.namelist),function(i,j){return _c('div',{staticClass:"tabslist flex jc ac f1 bgps",style:({
      backgroundImage: _vm.checkvalue == j ? `url(${_vm.src})` : '',
      color: _vm.checkvalue == j ? '#fff' : '#8AA0BC',
      fontSize:_vm.checkvalue == j ? '1rem' : '.9375rem',
      fontFamily:_vm.checkvalue == j ?'AlibabaPuHuiTi_2_75_SemiBold':'AlibabaPuHuiTi_2_55_Regular',
    }),on:{"mouseenter":function($event){_vm.checkvalue=j},"click":function($event){return _vm.tabclick(j)}}},[_vm._v(" "+_vm._s(i.label)),_c('span',[_vm._v(_vm._s(i.value ? ` ${i.value}` : ""))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }